export const MAX_UPLOAD_FILE_SIZE_MB = 10;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

export const getMaxUploadFileSizeMessage = () =>
  `O arquivo deve ter no máximo ${MAX_UPLOAD_FILE_SIZE_MB} MB.`;

export const getUploadLimitExceededMessage = () =>
  `O arquivo excede o limite de ${MAX_UPLOAD_FILE_SIZE_MB} MB e não pôde ser enviado.`;

export const isFileWithinUploadLimit = (file) => {
  if (!file || typeof file.size !== 'number') {
    return true;
  }
  return file.size <= MAX_UPLOAD_FILE_SIZE_BYTES;
};
